/**
 * <QuizReviewSkeleton> — la forme de la relecture du quiz pendant qu'elle se lit : l'anneau du score,
 * son mot, et trois questions repliées dans la carte-liste.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { CardList, CardListRow } from "../../molecules/CardList"
import { QUIZ_SCORE_RING_SIZE } from "../../molecules/QuizScore"

const ROWS = [0, 1, 2]

export function QuizReviewSkeleton() {
    return (
        <Stack gap="4">
            <Stack gap="2" align="center">
                <Skeleton shape="circle" size={QUIZ_SCORE_RING_SIZE} />
                <Skeleton textSize="text-base" width={120} />
            </Stack>
            <CardList>
                {ROWS.map((row) => (
                    <CardListRow key={row}>
                        <Row gap="3" style={styles.row}>
                            <Skeleton shape="chip" width={36} />
                            <Stack gap="1" style={styles.text}>
                                <Skeleton textSize="text-base" width="80%" />
                                <Skeleton textSize="text-sm" width="45%" />
                            </Stack>
                        </Row>
                    </CardListRow>
                ))}
            </CardList>
        </Stack>
    )
}

const styles = StyleSheet.create((theme) => ({
    row: { paddingVertical: theme.spacing["3"] },
    text: { flex: 1 },
}))
